module.exports = __webpack_public_path__ + "img/domuslogo.36c598d2.png";